// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3473": "c10b5a82","494": "40775784","7941": "580b09be",}[chunkId] + ".css"
}